import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import JavaSvgColor from '../assets/java.svg';

export const JavaColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-java" className={cx('sdkIcon', className)} size={size} {...props}>
    <JavaSvgColor />
  </LegacyIcon>
);
